import React from 'react';
import './NotFound.css';

const NotFound = () => (
  <div className="not-found-page">
    <div className="not-found-inner">
      <div className="not-found-status">404</div>
      <h1>Page not found</h1>
      <p>
        We couldn't find the page you were looking for. It may have been
        renamed, moved, or it may never have existed.
      </p>
      <div className="not-found-actions">
        <a href="/" className="btn-primary">
          Go to homepage
        </a>
        <a href="/resources" className="btn-secondary">
          Browse Ireland visa guides
        </a>
      </div>
      <p className="not-found-help">
        Still stuck? Email{' '}
        <a href="mailto:visahelp@irelandvisatracker.in">visahelp@irelandvisatracker.in</a>
        {' '}and we'll help.
      </p>
    </div>
  </div>
);

export default NotFound;
